import { Pipe, PipeTransform } from "@angular/core";
import { ProviderTypes } from "../_enums/provider-types.enum";

@Pipe({
    standalone: true,
    name: "providerType",
})
export class ProviderTypePipe implements PipeTransform {
    transform(value: number): string {
        return ProviderTypes[value];
    }
}
